// components/common/LoadingDots.jsx
// ─────────────────────────────────────────────────────────
// Loading screen ใช้ร่วมกันใน messenger-jobdetail และ messenger-joboverview
// ─────────────────────────────────────────────────────────

import React from 'react';
import { dotPulse } from 'ldrs';

dotPulse.register();

const LoadingDots = ({ text = 'กำลังโหลด...' }) => (
    <div className="mjd-loading-screen">
        <l-dot-pulse size="43" speed="1.3" color="#3B82F6" />
        <p className="mjd-loading-text">{text}</p>
    </div>
);

export default LoadingDots;